import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function PaymentPage() {
    const [searchParams] = useSearchParams();
    const [ready, setReady] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const sessionId = searchParams.get("session");

    useEffect(() => {
        if (!sessionId) return;

        const script = document.createElement("script");
        script.src =
            "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";
        script.setAttribute("data-error", "errorCallback");
        script.setAttribute("data-cancel", "cancelCallback");

        script.onload = () => setReady(true);

        document.body.appendChild(script);

        window.errorCallback = (error) => {
            alert("Payment Error ❌");
            console.log(error);
        };

        window.cancelCallback = () => {
            alert("Payment Cancelled ❌");
        };
    }, [sessionId]);

    const startPayment = () => {
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions");
            return;
        }

        if (!window.Checkout || !sessionId) {
            alert("Payment not ready");
            return;
        }

        window.Checkout.configure({
            session: { id: sessionId },
        });

        window.Checkout.showPaymentPage();
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 dark:bg-gray-950">

            <PageHeader
                title="Secure Payment"
                subtitle="Your transaction is encrypted and securely processed"
            />

            <section className="flex items-center justify-center px-4 py-16">

                <div className="
                    w-full max-w-lg

                    bg-white dark:bg-gray-900
                    border border-gray-200 dark:border-gray-800

                    rounded-2xl p-8

                    shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                    dark:shadow-[0_10px_30px_rgba(0,0,0,0.4)]

                    hover:shadow-[0_25px_60px_rgba(0,0,0,0.18)]
                    dark:hover:shadow-[0_25px_70px_rgba(0,0,0,0.6)]

                    transition-all duration-300
                ">

                    {/* TITLE */}
                    <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white">
                        🔒 Secure Payment Gateway
                    </h2>

                    <p className="text-sm text-center text-gray-600 dark:text-gray-400 mt-3 leading-relaxed">
                        Your payment is encrypted and securely processed through Mastercard Payment Gateway Services.
                    </p>

                    {/* CHECKBOX */}
                    <div className="flex items-start gap-3 mt-6">
                        <input
                            type="checkbox"
                            checked={accepted}
                            onChange={() => setAccepted(!accepted)}
                            className="mt-1 w-4 h-4"
                        />

                        <label className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                            I agree to the{" "}
                            <Link
                                to="/terms-conditions"
                                className="text-blue-600 dark:text-cyan-400 font-semibold hover:underline"
                            >
                                Terms & Conditions
                            </Link>{" "}
                            and{" "}
                            <Link
                                to="/privacy-policy"
                                className="text-blue-600 dark:text-cyan-400 font-semibold hover:underline"
                            >
                                Privacy Policy
                            </Link>
                        </label>
                    </div>

                    {/* BUTTON (NOW BLUE THEME) */}
                    <button
                        onClick={startPayment}
                        disabled={!ready || !accepted}
                        className={`
        w-full mt-6
        py-3 rounded-xl
        font-semibold text-white text-base

        bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700
        hover:from-blue-700 hover:via-cyan-600 hover:to-blue-800

        shadow-[0_10px_25px_rgba(59,130,246,0.25)]
        hover:shadow-[0_20px_50px_rgba(59,130,246,0.35)]

        transition-all duration-300

        disabled:opacity-60 disabled:cursor-not-allowed
    `}
                    >
                        {ready
                            ? "Proceed to Secure Payment"
                            : "Preparing Secure Checkout..."}
                    </button>

                </div>
            </section>
        </div>
    );
}